import JsxHelper from '../../../Helpers/JsxHelper';
import React from 'react';
import UserNameComponent from '../../../Elements/UserNameComponent';
import FieldTypesEnum from '../../../Enums/FieldTypesEnum';
import TabListTableCellWidthEnum from '../../../Enums/TabListTableCellWidthEnum';
import ThirdPartyJobPaymentsItem from './ThirdPartyJobPaymentsItem';
import LookupText from '../../../Elements/LookupText';

export default class VoidedThirdPartyJobPaymentsAdminItem extends ThirdPartyJobPaymentsItem {
  static FieldsToShowInDataTable() {
    return [
      {
        label: 'Pay ID',
        orderById: 'TpEvaluatorTpJobPaymentId',
        data: 'TpEvaluatorTpJobPaymentId',
        type: FieldTypesEnum.DataFieldWithDetails,
      },
      { label: 'Evaluator', orderById: 'EvaluatorName', data: 'EvaluatorName', minWidth: 100 },
      { label: 'Completed On', orderById: 'JobDate', data: 'JobDate', minWidth: 50 },
      { label: 'Fieldwork Office', orderById: 'FieldworkOfficeName', data: 'FieldworkOfficeName', minWidth: 50 },
      { label: 'Payment Office', orderById: 'EvaluatorOfficeName', data: 'EvaluatorOfficeName', minWidth: 50 },
      { label: 'Void Reason', orderById: 'VoidReason', data: 'VoidReason', minWidth: 50 },
      { label: 'Export', orderById: 'ExportId', data: 'ExportId', minWidth: 50 },
      { label: 'Type', orderById: 'TypeText', data: 'TypeText', minWidth: 120 },
      {
        label: 'Status',
        orderById: 'Status',
        data: (item) => (
          <LookupText
            lookupId={45}
            value={item.StatusCodeLookupValue}
          />
        ),
        minWidth: 50,
      },
      // CD-5421: sits directly after Status on purpose - it is what explains a Closed payment.
      {
        label: 'Paid Outside of System',
        orderById: 'PaidOutsideOfSystem',
        data: (item) => JsxHelper.YesNo(item.PaidOutsideOfSystem),
        minWidth: 20,
      },
      { label: 'Method', orderById: 'PaymentTypeText', data: 'PaymentTypeText', minWidth: 50 },
      { label: 'Fee', orderById: 'FeeDisplay', data: 'FeeDisplay', minWidth: 50 },
      { label: 'Fee Addit.', orderById: 'FeeAdjustment', data: 'FeeAdjustment', minWidth: 50 },
      { label: 'Expense', orderById: 'Expense', data: 'Expense', minWidth: 50 },
      { label: 'Tax', orderById: 'Vat', data: 'Vat', minWidth: 50 },
      {
        label: ' ',
        orderById: '',
        data: ThirdPartyJobPaymentsItem.getActionCellContent,
        type: FieldTypesEnum.ActionButton,
        minWidth: 50,
      },
    ];
  }

  static FieldsToShowInListTable = [
    {
      tabName: 'Info',
      tabLabel: 'Info',
      icon: 'fa-solid fa-info',
      data: [
        { label: 'Type', name: 'TypeText' },
        {
          label: 'Status',
          name: (item) => (
            <LookupText
              lookupId={45}
              value={item.StatusCodeLookupValue}
            />
          ),
        },
        { label: 'Paid Outside of System', name: (item) => JsxHelper.YesNo(item.PaidOutsideOfSystem) },
        { label: 'Assignment', name: VoidedThirdPartyJobPaymentsAdminItem.idFunction },
        { label: 'Pay ID', name: 'TpEvaluatorTpJobPaymentId' },
        { label: 'Location', name: 'ThirdPartyLocationName' },
        { label: 'Evaluator', name: 'EvaluatorName' },
        { label: 'Payment Office', name: 'EvaluatorOfficeName' },
        { label: 'Currency', name: 'EvaluatorCurrencyCode' },
        { label: 'Payment Method', name: 'PaymentTypeText' },
        { label: 'Payment Export Date', name: 'PaymentDate' },
        { label: 'Transaction Date', name: 'PaidOn' }, // TODO:
        { label: 'Approved On', name: 'ApprovedOnUtc' },
        { label: 'Created By', name: (item) => <UserNameComponent userId={item.CreatedBy} /> },
        { label: 'Assigned To', name: (item) => <UserNameComponent userId={item.AssignedTo} /> },
        { label: 'Submitted On', name: 'SubmittedOnUtc' },
        { label: 'Approved By', name: (item) => <UserNameComponent userId={item.ApprovedBy} /> },
        { label: 'Reprinted As', name: 'ReissuedToTpEvaluatorTpJobPaymentId' },
        { label: 'Reprinted From', name: 'ReissuedFromTpEvaluatorTpJobPaymentId' },
        { label: 'Void Reason', name: 'VoidReason', width: TabListTableCellWidthEnum.TwoLines },
        { label: 'Comment', name: 'Comment', width: TabListTableCellWidthEnum.TwoLines },
        { label: 'Fees', name: '-' },
        { label: 'Fee', name: 'FeeDisplay' },
        { label: 'Additional Fee', name: 'FeeAdjustment' },
        { label: 'Initial Total', name: 'TotalDisplay' },
        { label: 'Reimbursement', name: 'Reimbursement' },
        { label: 'Misc', name: 'Misc' },
        { label: 'Tax', name: 'Vat' },
        { label: 'Travel', name: 'Travel' },
        { label: 'Paid', name: 'PaidDisplay' },
        { label: 'Gaming', name: 'Gaming' },
        { label: 'Current Total Due', name: 'Due' },
        { label: 'Export', name: '-' },
        { label: 'Export Payment', name: 'ExportPaymentId' },
        { label: 'Export', name: 'ExportId' },
      ],
    },
  ];
}
